/**
 * Иконка ПК + облако (карточка Cloud & DevOps).
 */

function IconDevops() {
    return (
        <svg viewBox="0 0 102 36" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
            <defs>
                <filter id="pcGlow" x="-40%" y="-40%" width="180%" height="180%">
                    <feGaussianBlur stdDeviation="0.6" result="blur"/>
                    <feMerge>
                        <feMergeNode in="blur"/>
                        <feMergeNode in="SourceGraphic"/>
                    </feMerge>
                </filter>
            </defs>
            <g transform="scale(1.13)">
                {/* Monitor screen */}
                <g filter="url(#pcGlow)">
                    <rect x="1" y="3" width="22" height="15" rx="2" stroke="#B8FF65" strokeWidth="1.5"/>
                    <rect x="10.5" y="18" width="3" height="4" stroke="#B8FF65" strokeWidth="1.5"/>
                    <rect x="7" y="22" width="10" height="2.5" rx="1.5" stroke="#B8FF65" strokeWidth="1.5"/>
                </g>
                {/* Right arrow */}
                <line x1="36" y1="14" x2="50" y2="14" stroke="#B8FF65" strokeWidth="2" strokeLinecap="round"/>
                <polyline points="45,10 50,14 45,18" stroke="#B8FF65" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" fill="none"/>
                {/* Cloud — filled, scaled */}
                <g transform="translate(54, 1) scale(0.56)">
                    <path d="M32 4C20 4 12 12 12 22C6 22 4 26 4 30C4 38 10 42 18 42L46 42C54 42 60 38 60 30C60 24 56 20 50 20C48 10 40 4 32 4Z" fill="#B8FF65"/>
                </g>
            </g>
        </svg>
    );
}

export default IconDevops;
// assets/icons/IconDevops.js
